module.exports = __webpack_public_path__ + "static/media/map.e2f19356.png";